import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PhoneResendMFA from '../PhoneResendMFA';

const container = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  mt: 1,
};

const AccordionOptions = ({ onUpdate }) => (
  <Accordion
    elevation={0}
    sx={{
      borderRadius: '8px !important',
      '&:before': {
        display: 'none',
      },
      '&:hover, &.Mui-expanded': {
        backgroundColor: '#FAFAFA',
      },
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      sx={{
        '& .MuiAccordionSummary-content': {
          flexGrow: 0,
        },
      }}
    >
      <Typography variant="subtitle2" sx={{ color: 'info.main', mr: 2 }}>
        Didn&apos;t receive a code?
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant="body2" sx={{ color: 'info.main' }}>
        Network issues or phone settings may block messages. Confirm your phone
        number and request a new code. If you previously opted out, text
        {' '}
        <b>START</b>
        {' '}
        to
        {' '}
        <b>95679</b>
        .
      </Typography>
      <Box sx={container}>
        <PhoneResendMFA />
        <Typography sx={{ color: 'info.main' }}>|</Typography>
        <Button
          variant="text"
          onClick={onUpdate}
        >
          Change number
        </Button>
      </Box>
    </AccordionDetails>
  </Accordion>
);

export default AccordionOptions;
